/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import {
  BaseAlertCardTaskFragmentDoc,
  BaseAlertCardVehicleFragmentDoc,
} from '../../../../alert-cards-common/src/lib/BaseAlertCard/BaseAlertCard.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { DefaultActionsOpenAlertFragmentDoc } from '../components/DefaultActionsOpenAlert/defaultActionsOpenAlert.hook'
import {
  DefaultMetaInProgressAlertEmployeeFragmentDoc,
  DefaultMetaInProgressAlertVehicleFragmentDoc,
} from '../components/DefaultMetaInProgressAlert/defaultMetaInProgressAlert.hook'
import { DefaultMetaNewAlertEmployeeFragmentDoc } from '../components/DefaultMetaNewAlert/defaultMetaNewAlert.hook'
import { DefaultAlertCardDataAlertFragmentDoc } from '../hook/useDefaultAlertCardData/useDefaultAlertCardData.hook'
export type NoBookingAlertCardAlertFragment = {
  __typename: 'VehicleSurveillanceNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  employee: {
    __typename?: 'Employee'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    totalPassengersInVehicle: number | null
    inService: boolean | null
    label: number | null
    isSelfDriving: boolean
    hardwareConfiguration: {
      __typename?: 'HardwareConfiguration'
      tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
    } | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const NoBookingAlertCardAlertFragmentDoc = gql`
    fragment NoBookingAlertCardAlert on VehicleSurveillanceNotification {
  id
  status
  employee {
    ...DefaultMetaNewAlertEmployee
    ...DefaultMetaInProgressAlertEmployee
  }
  vehicle {
    id
    ...DefaultMetaInProgressAlertVehicle
    ...BaseAlertCardVehicle
  }
  ...DefaultActionsOpenAlert
  ...DefaultAlertCardDataAlert
  ...BaseAlertCardTask
}
    ${DefaultMetaNewAlertEmployeeFragmentDoc}
${DefaultMetaInProgressAlertEmployeeFragmentDoc}
${DefaultMetaInProgressAlertVehicleFragmentDoc}
${BaseAlertCardVehicleFragmentDoc}
${DefaultActionsOpenAlertFragmentDoc}
${DefaultAlertCardDataAlertFragmentDoc}
${BaseAlertCardTaskFragmentDoc}`
